module.exports = __webpack_public_path__ + "assets/img/AfterSale1.6cbf29c3.png";